import { type SearchRequest } from '@searchkit/api';

import { createResponseFactory } from '~/search-domain/pipelines/match-centre/response-factory';
import { type MatchupCentreESResultBody } from '~/search-domain/pipelines/match-centre/types';
import { type SearchDomainContext } from '~/search-domain/types';
import { createElasticSearchContext, createResponseFactoryContext } from '~/search-domain/utils';

export async function transformMatchupCentreResponse(
  context: SearchDomainContext,
  { searchRequest, searchResponse }: { searchRequest: SearchRequest; searchResponse: MatchupCentreESResultBody },
) {
  const requestType = searchRequest?.request?.type;
  const params = searchRequest?.request?.params;
  if (requestType === 'facet' || !params) {
    return searchResponse;
  }

  const hitsPerPage = params.hitsPerPage ?? 10;
  const page = params.page ?? 0;
  const from = page * hitsPerPage;

  const elasticContext = createElasticSearchContext(context);

  return createResponseFactory.call(
    createResponseFactoryContext(context),
    elasticContext,
    searchResponse,
    from,
    hitsPerPage,
  );
}
